/*
  Bloco ".box-cont" (números animados + carrossel dos .item)

  Feito para funcionar em QUALQUER quantidade de blocos iguais na página: se
  a estrutura (.box-cont > .box-dados > .item > .num > .num-value[data-target])
  for clonada em outra section com outros valores, basta trocar os
  data-target/textos — nada aqui depende de #ead nem de um id específico.

  1. Contador (.num-value[data-target]): conta de 0 até o valor final quando
     o .item pai ganha a classe "animado" — é o mesmo "callback" que o
     site.js usa em aplicaDelaysAnimacao() pra marcar que a animação de
     entrada (ex.: .slide-up) daquele elemento terminou. Ou seja: o número
     só começa a contar depois que o item já apareceu na tela.
  2. Carrossel (.item dentro de .box-dados > .track): só ativa em telas
     <= 910px, mostrando 2 itens por vez; <= 768px (mobile clássico) mostra
     1 item por vez (ver larguras em _ead.scss). Este script desliza só o
     .track em autoplay, uma posição por vez (janela deslizante) — o
     .box-dados (fundo/borda arredondada) fica parado, só recorta o track.
*/
(function () {

    /* ==========================================================
    Contador 0 -> valor
    =========================================================== */
    // mesma lista de classes que o site.js usa em aplicaDelaysAnimacao()
    // (ver comum/_animacoes.scss) — serve só pra saber se o .item pai faz
    // parte do sistema de reveal (e portanto vai ganhar ".animado" cedo ou tarde)
    var CLASSES_ANIMACAO = [
        'slide-up', 'slide-down', 'slide-left', 'slide-right',
        'zoom-in', 'zoom-in-pa', 'zoom-out',
        'gira-direita', 'gira-esquerda', 'shake',
        'espelho', 'fade', 'flutua', 'gira', 'pulsar', 'girando'
    ];

    function temClasseDeAnimacao(el) {
        return CLASSES_ANIMACAO.some(function (c) { return el.classList.contains(c); });
    }

    function animaContador(el) {
        var alvo = parseInt(el.getAttribute('data-target'), 10) || 0;
        var duracao = 2800; // ms (metade da velocidade do que era antes: 1400 -> 2800)
        var inicio = null;

        function passo(tMs) {
            if (inicio === null) inicio = tMs;
            var progresso = Math.min((tMs - inicio) / duracao, 1);
            var facil = 1 - Math.pow(1 - progresso, 3); // ease-out cubic
            el.textContent = Math.round(alvo * facil);
            if (progresso < 1) requestAnimationFrame(passo);
        }
        requestAnimationFrame(passo);
    }

    // dispara animaContador(el) assim que o .item pai ganhar ".animado"
    function aguardaAnimado(el) {
        // o HTML já traz o valor final em texto (fallback sem JS / leitor de
        // tela antes da animação rodar) — aqui zera na hora, antes de esperar
        // o ".animado", pra não piscar o valor final enquanto o item ainda
        // está entrando na tela (aí sim o animaContador conta 0 -> alvo)
        el.textContent = '0';

        var item = el.closest('.item');

        if (item && temClasseDeAnimacao(item)) {
            if (item.classList.contains('animado')) {
                animaContador(el); // callback do site.js já tinha rodado antes deste script
                return;
            }
            var mo = new MutationObserver(function () {
                if (item.classList.contains('animado')) {
                    mo.disconnect();
                    animaContador(el);
                }
            });
            mo.observe(item, { attributes: true, attributeFilter: ['class'] });
            return;
        }

        // sem .item com classe de animação (uso fora do padrão .item.slide-up) —
        // fallback: anima ao entrar na tela, do jeito que era antes
        if ('IntersectionObserver' in window) {
            var obs = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    animaContador(entry.target);
                    obs.unobserve(entry.target);
                });
            }, { threshold: 0.4 });
            obs.observe(el);
        } else {
            animaContador(el);
        }
    }

    Array.prototype.slice.call(document.querySelectorAll('.num-value[data-target]')).forEach(aguardaAnimado);

    /* ==========================================================
    Carrossel autoplay dos .item
    =========================================================== */
    // true  = dá a impressão de loop infinito (nunca parece "voltar seco" pro início)
    // false = comportamento antigo: avança e, ao chegar no fim, pula de volta pro índice 0
    var INFINITO = true;

    var INTERVALO_AUTOPLAY = 3500; // ms

    // ordem importa: a primeira faixa cuja media query bater é a usada
    // (768px é subconjunto de 910px, por isso vem primeiro)
    var FAIXAS = [
        { query: '(max-width: 768px)', itensPorVez: 1 },
        { query: '(max-width: 910px)', itensPorVez: 2 }
    ];
    var ITENS_POR_VEZ_MAX = Math.max.apply(null, FAIXAS.map(function (f) { return f.itensPorVez; }));

    function itensPorVezAtual() {
        for (var i = 0; i < FAIXAS.length; i++) {
            if (window.matchMedia(FAIXAS[i].query).matches) return FAIXAS[i].itensPorVez;
        }
        return null; // nenhuma faixa bateu = desktop, sem carrossel
    }

    var blocos = Array.prototype.slice.call(document.querySelectorAll('.box-cont'));

    blocos.forEach(function (boxCont) {
        var boxDados = boxCont.querySelector('.box-dados');
        var track = boxDados ? boxDados.querySelector('.track') : null;
        if (!track) return;

        var itens = Array.prototype.slice.call(track.children).filter(function (el) {
            return el.classList.contains('item');
        });
        if (itens.length < 2) return;

        // modo infinito: clona os primeiros ITENS_POR_VEZ_MAX itens e cola no fim
        // do track. O autoplay só anda pra frente, então basta ter clones ali —
        // quando o índice "entra" neles, a tela mostra exatamente a mesma coisa
        // que o índice 0 mostraria; nesse instante a gente troca pro índice 0 de
        // verdade sem transição, e o olho não percebe o corte.
        var clones = [];
        if (INFINITO) {
            for (var c = 0; c < ITENS_POR_VEZ_MAX && c < itens.length; c++) {
                var clone = itens[c].cloneNode(true);
                clone.classList.add('item--clone');
                clone.classList.remove('slide-up', 'animado');
                clone.setAttribute('aria-hidden', 'true');

                var numClone = clone.querySelector('.num-value[data-target]');
                if (numClone) numClone.textContent = numClone.getAttribute('data-target'); // sem animar, só "flash" visual

                track.appendChild(clone);
                clones.push(clone);
            }
        }

        var indice = 0;
        var timer = null;
        var itensPorVez = null; // null = carrossel desligado (desktop)

        // distância real (em px) entre dois itens; cobre padding/gap sem
        // precisar recalcular percentuais na mão
        function larguraPasso() {
            return itens[1].getBoundingClientRect().left - itens[0].getBoundingClientRect().left;
        }

        // última posição possível sem deixar "buraco" depois do último item (modo não-infinito)
        function indiceMaximo() {
            return Math.max(itens.length - itensPorVez, 0);
        }

        // no modo infinito, ao chegar aqui a janela visível == janela do índice 0
        // (graças aos clones), então é o gatilho pra "costurar" de volta pro início
        function indiceLimiteInfinito() {
            return itens.length;
        }

        // marca .visivel nos itens (e clones) dentro da janela atual; o resto
        // perde a classe e some via opacity:0 (transição definida no _ead.scss)
        function atualizaVisibilidade() {
            itens.forEach(function (el, i) {
                var dentroDaJanela = itensPorVez !== null && i >= indice && i < indice + itensPorVez;

                // modo infinito: enquanto o CLONE deste item estiver na janela
                // (posição i + itens.length), o item real já entra em opacity:1
                // também — mesmo fora de tela, ninguém vê. Assim, quando o salto
                // pro índice 0 acontece, ele já está pronto e não pisca refazendo
                // o fade-in do zero.
                if (!dentroDaJanela && INFINITO && itensPorVez !== null) {
                    var posicaoClone = i + itens.length;
                    dentroDaJanela = posicaoClone >= indice && posicaoClone < indice + itensPorVez;
                }

                el.classList.toggle('visivel', dentroDaJanela);
            });
            clones.forEach(function (el, i) {
                var posicao = itens.length + i;
                var dentroDaJanela = itensPorVez !== null && posicao >= indice && posicao < indice + itensPorVez;
                el.classList.toggle('visivel', dentroDaJanela);
            });
        }

        function aplicaTransform(semTransicao) {
            if (semTransicao) track.style.transition = 'none';
            track.style.transform = 'translateX(-' + (larguraPasso() * indice) + 'px)';
            if (semTransicao) {
                track.getBoundingClientRect(); // força reflow antes de devolver a transição
                track.style.transition = '';
            }
            atualizaVisibilidade();
        }

        function vaiPara(i) {
            if (INFINITO) {
                indice = Math.max(i, 0); // só anda pra frente; o "wrap" é tratado no transitionend
            } else {
                var max = indiceMaximo();
                indice = max > 0 ? ((i % (max + 1)) + (max + 1)) % (max + 1) : 0;
            }
            aplicaTransform(false);
        }

        // assim que a transição pro "trecho clonado" termina, volta pro índice 0
        // de verdade sem transição — a costura fica invisível
        track.addEventListener('transitionend', function (e) {
            if (e.target !== track || e.propertyName !== 'transform') return;
            if (INFINITO && indice >= indiceLimiteInfinito()) {
                indice = 0;
                aplicaTransform(true);
            }
        });

        function pararAutoplay() {
            if (timer) {
                clearInterval(timer);
                timer = null;
            }
        }

        function iniciarAutoplay() {
            pararAutoplay();
            timer = setInterval(function () { vaiPara(indice + 1); }, INTERVALO_AUTOPLAY);
        }

        function desativarCarrossel() {
            pararAutoplay();
            itensPorVez = null;
            indice = 0;
            track.style.transform = '';
            atualizaVisibilidade(); // remove .visivel de todos (desktop não usa a classe)
        }

        // liga/troca de faixa (ex.: desktop -> 2 por vez -> 1 por vez) do zero
        function sincroniza() {
            var novo = itensPorVezAtual();

            if (novo === null || novo >= itens.length) {
                desativarCarrossel();
                return;
            }

            itensPorVez = novo;
            vaiPara(0);
            iniciarAutoplay();
        }

        sincroniza();

        window.addEventListener('resize', function () {
            var novo = itensPorVezAtual();
            if (novo !== itensPorVez) {
                sincroniza(); // mudou de faixa (ou saiu do carrossel) — reinicia
            } else if (itensPorVez !== null) {
                vaiPara(indice); // mesma faixa, só recalcula a posição em px
            }
        });
    });

})();
